<template>
	<Modal
		v-model="opened"
		:modal-class="'main-menu-drawer ' + position"
		:in-class="'slide' + position"
		:out-class="'slide' + position + '-out'"
		@before-open="onBeforeOpen"
		@before-close="onBeforeClose"
	>
		<template #titlebar>
			<div />
		</template>

		<sidebar-block v-if="content=='main-menu'" @click="opened=false" @on-navigation="onNavigation" @on-side-menu-close="opened=false" />
	</Modal>
</template>

<script setup>
import { computed, ref } from 'vue';
import bodyScrollPlugin from 'body-scroll-freezer'
import SidebarBlock from './sidebar-block.vue'
import { Modal } from '@kouts/vue-modal'
import { $on } from '@/js/includes/event-bus';
import { useStore } from '@/js/stores/index';

const store = useStore()

// Reactives
const opened = ref(false)
const position = ref("right")
const content = ref("main-menu") // This is used for custom implmentations to reuse same drawer for different content
const navigatingForward = ref(false)

// Computeds
const t = computed(() => store.translations)

// Methods
// We need to get the information whether the navigation of the sub-component is forward or back
function onNavigation(){
	navigatingForward.value = true
}

function onBeforeOpen(){
	// Save menu opening to history, so we can use "back" to close it
	history.state.modalOpen = true
	history.pushState(history.state, '')

	bodyScrollPlugin.freeze()
}

function onBeforeClose(){
	// If the modal is open and navigation is not forward
	// (means it is "back") do hisotry.go(-1) to remove this page from history
	if(history.state.modalOpen && !navigatingForward.value){
		history.go(-1)
	}

	bodyScrollPlugin.unfreeze()
}

// Events
$on('open-side-menu', (params = {}) => {
	content.value = params.content || "main-menu"
	opened.value = true
})

// Close menu on any back/forward navigation
window.addEventListener('popstate', () => {
	if(opened.value) opened.value = false
})
</script>